import cx from "classnames";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Product from "../../components/Product/Product";
import ProductSkeleton from "../../components/Product/ProductSkeleton";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { getSpecialProducts } from "../../services/api/products";
import styles from "./Specials.module.css";

function Specials() {
  const { width } = useWindowDimensions();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let abort = new AbortController();
    setLoading(true);
    getSpecialProducts(abort.signal)
      .then((res) => {
        setProducts(res.data.products);
        setLoading(false);
      })
      .catch((err) => {})
      .finally(() =>
        setTimeout(() => {
          setLoading(false);
        }, 1000)
      );

    return () => {
      abort.abort();
    };
  }, []);
  return (
    <section className={cx("section", styles.topProduct)}>
      <div className="container">
        <div className={styles.headerContainer}>
          <h2 className={cx("h2", "section-title", styles.sectionTitle)}>Barahi Special</h2>
          <button
            className={styles.viewAllBtn}
            onClick={() =>
              navigate("/barahi-specials/", {
                state: {
                  category: "Barahi Special Products",
                },
              })
            }
          >
            View All <ion-icon name="chevron-forward-outline"></ion-icon>
          </button>
        </div>

        {loading ? (
          <div className={cx(styles.topProductList, "grid-list")}>
            <ProductSkeleton />
            <ProductSkeleton />
            <ProductSkeleton />
            <ProductSkeleton />
          </div>
        ) : (
          <div className={cx(styles.topProductList, "grid-list")}>
            {products.map((item, index) => (
              <Product item={item} key={item.id} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default Specials;
